import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "min", "max", "step"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Slider',
  props: {
    modelValue: null,
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:modelValue', value: number): void
  (event: 'change'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number, min: number, max: number, step: number };

_useCssVars(_ctx => ({
  "6ec109ba": (_unref(valueAsPercentage))
}))





const valueAsPercentage = computed(() => (props.modelValue - props.min) / (props.max - props.min) * 100 + '%')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    class: "slider",
    type: "range",
    value: __props.modelValue,
    min: __props.min,
    max: __props.max,
    step: __props.step,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (emits('update:modelValue', ($event.target as HTMLInputElement).valueAsNumber))),
    onChange: _cache[1] || (_cache[1] = ($event: any) => (emits('change'))),
    tabindex: "-1"
  }, null, 40, _hoisted_1))
}
}

})